<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form :inline="true" size="mini" label-width="100px" :model="searchForm" :rules="rules" ref="searchForm">
          <el-form-item label="登记日期" prop="registerDt">
            <el-date-picker v-model="searchForm.registerDt" type="date" value-format="yyyy-MM-dd" placeholder="年/月/日" />
          </el-form-item>
          <el-form-item label="店铺简称" prop="storeCode">
            <el-select v-model="searchForm.storeCode" filterable clearable placeholder="请选择" @change="onSearch">
              <el-option label="全部" value="" />
              <el-option v-for="item in storeList" :key="item.storeCode" :label="item.storeName" :value="item.storeCode"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客服ID" prop="customerServiceId">
            <el-input v-model.trim="searchForm.customerServiceId" @keyup.enter.native="onSearch" placeholder="请输入" />
          </el-form-item>
          <el-form-item label="质检人" prop="qualityPerson">
            <el-input v-model.trim="searchForm.qualityPerson" @keyup.enter.native="onSearch" placeholder="请输入" />
          </el-form-item>
          <el-form-item label="姓名" prop="userName">
            <el-input v-model.trim="searchForm.userName" @keyup.enter.native="onSearch" placeholder="请输入" />
          </el-form-item>
          <el-form-item label="工号" prop="workNo">
            <el-input v-model.trim="searchForm.workNo" @keyup.enter.native="onSearch" placeholder="请输入" />
          </el-form-item>
          <el-form-item label="审核结果" prop="auditResult" v-if="activeTab == 'finished'">
            <el-select v-model="searchForm.auditResult" clearable @change="onSearch">
              <el-option label="全部" value="" />
              <!-- <el-option label="待审核" value="0" />
              <el-option label="审核超时" value="1" /> -->
              <el-option label="申诉成功" value="2" />
              <el-option label="申诉失败" value="3" />
              <!-- <el-option label="申诉成功与申诉失败" value="4" /> -->
            </el-select>
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button class="green-btn" size="mini" @click="onSearch">搜索</el-button>
          <el-button class="orange-btn" size="mini" @click="reset">重置</el-button>
        </template>
      </search-box>
    </template>
    <el-row class="tabs-row">
      <el-col :span="10">
        <el-tabs v-model="activeTab" @tab-click="handleTabClick" class="tabs">
          <el-tab-pane v-for="(item, index) in tablesNumber" :name="item.name" :key="item.name">
            <span slot="label">
              {{ item.label }}<span v-if="index === 0" style="color: red;">{{ item.num }}</span><span v-else>{{ item.num }}</span>
            </span>
          </el-tab-pane>
        </el-tabs>
      </el-col>
      <el-col :span="14" class="table-btn-area">
        <el-button type="primary" size="mini" @click="exportExcel">导出</el-button>
      </el-col>
    </el-row>
    <table-panel ref="tablePanel">
      <el-table
        stripe
        border
        ref="tableRef"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
        highlight-current-row
        :data="tableData.list"
        :height="maxTableHeight"
        v-if="isShowTable"
        v-loading="loading"
      >
        <el-table-column
          v-for="column in columnObj[activeTab]"
          :key="column.prop"
          :label="column.label"
          :prop="column.prop"
          :min-width="column.minWidth"
          :align="column.align"
          show-overflow-tooltip
        >
          <template slot-scope="{ row }">
            <template v-if="column.type === 'image'">
              <el-button type="text" v-if="row[column.prop] && row[column.prop].length" @click="imgShow(row[column.prop])">查看</el-button>
              <!-- <el-image
                v-if="row[column.prop] && row[column.prop].length"
                :src="row[column.prop][0]"
                :preview-src-list="row[column.prop]"
                :initial-index="0"
                fit="cover"
                style="width: 50px; height: 50px; cursor: pointer;"
              >
              </el-image> -->
            </template>
            <template v-else>
              {{ row[column.prop] }}
            </template>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" min-width="80" align="center">
          <template slot-scope="{ row }">
            <el-button type="text" size="mini" @click="review(row)" v-if="activeTab == 'pending'">审核</el-button>
            <el-button type="text" size="mini" @click="onView(row)" v-else>查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 100, 500, 1000]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :total="tableData.total"
          ></el-pagination>
        </div>
      </template>
    </table-panel>
    <el-image
      ref="imgViewRef"
      :src="imgList[0]"
      :preview-src-list="imgList"
      :initial-index="0"
      fit="cover"
      style="width: 100 px; height:100px;display: none;"
    >
    </el-image>
    <!-- 审核 -->
    <review-dialog :visible.sync="isShowReview" v-if="isShowReview" :rowData="rowData"  @success="onSearch"/>
    <!-- 查看图片弹窗 -->
    <el-dialog title="图片查看" :visible.sync="imgVisible" v-if="imgVisible" :close-on-click-modal="false" width="50%" v-esc-close><imgShow :imgList="imgList"></imgShow></el-dialog>
  </content-panel>
</template>

<script>
import pagePathMixin from '@/utils/page-path-mixin';
import tableMixin from '@/utils/tableMixin';
import reviewDialog from './components/review';
import viewDialog from './components/view.vue';
import axios from '@/utils/axiosInstance';

export default {
  name: 'photographySalaryAccounting',
  mixins: [tableMixin, pagePathMixin],
  components: { reviewDialog, viewDialog },
  data() {
    return {
      loading: false,
      isShowReview: false,
      isShowView: false,
      isShowTable: true,
      imgList: true,
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      searchFormData: {},
      rules: {},
      rowData: {},
      reportName: 'newProductPictureRetouchDetailInfo',
      columnData: [],
      loading: false,
      searchForm: {
        registerDt: '',
        storeCode: '',
        customerServiceId: '',
        isQualified: '',
        qualityPerson: '',
        userName: '',
        workNo: '',
        isAppeal: '',
        confirmResult: '',
        reviewResult: '',
        auditResult: '',
      },
      exportData: {},
      searchCollapse: false,
      queryCriteria: [],
      spuCategoryList: [],
      goodsLocationList: [],
      storeList: [],
      tablesNumber: [
        { label: '待审核', name: 'pending', num: '' },
        { label: '审核完成', name: 'finished', num: '' },
      ],
      activeTab: 'pending',
      columnObj: {
        pending: [
          { label: '质检人', prop: 'qualityPersonName', minWidth: '90' },
          { label: '年/月', prop: 'yearMonth', minWidth: '90' },
          { label: '周', prop: 'week', minWidth: '80' },
          { label: '登记日期', prop: 'registerDt', minWidth: '110' },
          { label: '会话日期', prop: 'sessionDt', minWidth: '110' },
          { label: '店铺简称', prop: 'storeShoreName', minWidth: '100' },
          { label: '店铺全称', prop: 'storeName', minWidth: '150' },
          { label: '客户ID', prop: 'customerId', minWidth: '120' },
          { label: '客服ID', prop: 'customerServiceId', minWidth: '120' },
          { label: '姓名', prop: 'userName', minWidth: '80' },
          { label: '工号', prop: 'workNo', minWidth: '110' },
          { label: '岗位', prop: 'workJobs', minWidth: '150' },
          { label: '客服等级', prop: 'customerServiceLevel', minWidth: '100' },
          { label: '入职日期', prop: 'entryDate', minWidth: '110' },
          { label: '责任部门', prop: 'responsibleDepartment', minWidth: '120' },
          { label: '是否合格', prop: 'qualified', minWidth: '90' },
          { label: '质检来源', prop: 'qualitySource', minWidth: '100' },
          { label: '质检条目', prop: 'checkCategory', minWidth: '100' },
          { label: '违规项', prop: 'categoryDetail', minWidth: '100' },
          { label: '场景', prop: 'violation', minWidth: '100' },
          { label: '问题描述', prop: 'problemDesc', minWidth: '150' },
          { label: '质检截图', prop: 'qualityImgList', minWidth: '120', align: 'center', type: 'image' },
          { label: '扣分', prop: 'deductPoints', minWidth: '60',},
          { label: '备注', prop: 'remark', minWidth: '200' },
          { label: '申诉原因', prop: 'appealReason', minWidth: '120' },
          { label: '申诉材料', prop: 'appealImgList', minWidth: '120', align: 'center',  type: 'image'  },
        ],
        finished: [
          { label: '质检人', prop: 'qualityPersonName', minWidth: '90' },
          { label: '年/月', prop: 'yearMonth', minWidth: '90' },
          { label: '周', prop: 'week', minWidth: '80' },
          { label: '登记日期', prop: 'registerDt', minWidth: '110' },
          { label: '会话日期', prop: 'sessionDt', minWidth: '110' },
          { label: '店铺简称', prop: 'storeShoreName', minWidth: '100' },
          { label: '店铺全称', prop: 'storeName', minWidth: '150' },
          { label: '客户ID', prop: 'customerId', minWidth: '120' },
          { label: '客服ID', prop: 'customerServiceId', minWidth: '120' },
          { label: '姓名', prop: 'userName', minWidth: '80' },
          { label: '工号', prop: 'workNo', minWidth: '110' },
          { label: '岗位', prop: 'workJobs', minWidth: '150' },
          { label: '客服等级', prop: 'customerServiceLevel', minWidth: '100' },
          { label: '入职日期', prop: 'entryDate', minWidth: '110' },
          { label: '责任部门', prop: 'responsibleDepartment', minWidth: '120' },
          { label: '是否合格', prop: 'qualified', minWidth: '90' },
          { label: '质检来源', prop: 'qualitySource', minWidth: '100' },
          { label: '质检条目', prop: 'checkCategory', minWidth: '100' },
          { label: '违规项', prop: 'categoryDetail', minWidth: '100' },
          { label: '场景', prop: 'violation', minWidth: '100' },
          { label: '问题描述', prop: 'problemDesc', minWidth: '150' },
          { label: '质检截图', prop: 'qualityImgList', minWidth: '120', align: 'center', type: 'image' },
          { label: '扣分', prop: 'deductPoints', minWidth: '60' },
          { label: '备注', prop: 'remark', minWidth: '200' },
          { label: '申诉原因', prop: 'appealReason', minWidth: '120' },
          { label: '申诉材料', prop: 'appealImgList', minWidth: '120', align: 'center', type: 'image' },
          { label: '申诉人', prop: 'appealUserName', minWidth: '80' },
          { label: '申诉时间', prop: 'appealDt', minWidth: '110' },
          // { label: '确认结果', prop: 'confirmResult', minWidth: '90' },
          // { label: '确认人', prop: 'confirmUserName', minWidth: '80' },
          // { label: '确认时间', prop: 'confirmDt', minWidth: '160' },
          { label: '质检审核结果', prop: 'auditResult', minWidth: '120' },
          { label: '质检审核描述', prop: 'auditReason', minWidth: '200' },
          { label: '审核人', prop: 'auditUserName', minWidth: '80' },
          { label: '审核时间', prop: 'auditDt', minWidth: '160' },
        ],
      },
      currencyForm: {
        pageSize: 999999,
        pageNum: 1,
        reportCode: '',
        hasCount: 'N',
      }
    };
  },
  computed: {},
  methods: {
    onSearch() {
      this.tableData.pageNum = 1;
      this.init();
      setTimeout(() => {
        this.getNumber();
      }, 50);
    },
    async init() {
      this.loading = true;
      let { workNo } = this.searchForm;
      let data = {
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
        filterData: {
          ...this.searchForm,
          workNo: workNo ? workNo.toUpperCase() : '',
          type: this.activeTab == 'pending' ? 2 : 3,
        },
      };
      this.searchFormData = data;
      this.$q.qualityTestingManage
        .registerPage({ data: data })
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init(this.searchFormData);
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init(this.searchFormData);
    },

    reset() {
      this.$refs.searchForm.resetFields();
      this.tableData.pageNum = 1;
      this.onSearch();
    },
    review(row) {
      this.rowData = row ? { ...row } : row;
      this.isShowReview = true;
    },

    imgShow(imgList) {
      this.imgList = []
      this.imgList = imgList;
      setTimeout(_=>{
        this.$refs.imgViewRef.$el.children[0].click();
      },500)
    },

    // 查看详情
    onView(row) {
      this.rowData = { ...row };
      this.isShowView = true;
    },

    // 查看图片
    viewImg(imgList) {
      this.imgVisible = true;
      this.imgList = imgList;
    },

    //获取数字
    getNumber() {
      let data = this.searchFormData;
      this.$q.qualityTestingManage.registerStatics({ data: data }).then((res) => {
        this.tablesNumber[0].num = res.data.waitQty || '';
        this.tablesNumber[1].num = res.data.finishQty || '';
      });
    },

    //店铺
    getUserStoreList() {
      let currencyForm = JSON.parse(JSON.stringify(this.currencyForm));
      currencyForm.reportCode = 'storeInfoList';
      axios.post(`/ec-pc-api/custom/reports/data/storeInfoList`, currencyForm).then((res) => {
        if (res.code == 200) {
          this.storeList = res.data.list;
        }
      });
    },

    // 导出
    exportExcel() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      let params = {
        appCode: 'ec-pc-new',
        // paramMap: this.searchFormData.filterData,
        paramMap: {
          ...this.searchFormData.filterData,
        },
        reportName: this.activeTab == 'pending' ? 'qualityAuditExport' : 'qualityAuditFinishExport',
      };
      this.$q.common.exportExcel({ data: params }).then((res) => {
        if (res.success) {
          this.$message.success('提交下载任务成功，请稍后到导出列表查阅！');
          loading.close();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    handleTabClick() {
      this.isShowTable = false;
      this.$nextTick((_) => {
        this.isShowTable = true;
      });
      this.onSearch();
    },
  },
  filters: {
    cellValFormat(val) {
      if (val) {
        return val;
      } else {
        if (isNaN(val) || val == 0) {
          return val;
        } else {
          return '--';
        }
      }
    },
  },
  mounted() {
    this.onSearch();
    this.getUserStoreList();
  },
};
</script>

<style lang="stylus" scoped>
.search-box
  >>> .el-date-editor.el-input__inner, >>> .el-select, >>> .el-input
      width 240px !important
.table-btn-area {
  text-align: right;
  line-height: 40px;
}
.tabs-row {
  margin-bottom: 5px;
}

.tabs {
  >>> .el-tabs__header {
    margin: 0 !important;
  }
}
</style>
